export default __webpack_public_path__ + "static/media/Group 2032@3x.87f74cdc.png";